import { Card, Container, Header, Icon, type IconJVSProps, Segment } from '@mairistem/composants';
import _ from 'lodash';
import type React from 'react';

interface Props {
  /** Header */
  header: string | React.ReactNode;
  /** Subheader */
  subheader?: string | React.ReactNode;
  /** Nom de l'icône Lucide à afficher */
  iconName?: IconJVSProps['name'];
  /** Enfant du composant */
  children?: React.ReactNode;
  onClick?: () => void;
  selectable?: boolean;
  selected?: boolean;
}

const Tile = ({
  header,
  subheader,
  iconName = 'Landmark',
  children = null,
  onClick,
  selectable,
  selected,
}: Props) => (
  <Container
    // fluid
    style={{ width: 'fit-content', margin: 0 }}
  >
    <Segment
      // tile + 5 premiers caractères du header pour éviter les doublons
      data-testid={`tile-${_.isString(header) ? header.toLowerCase().substring(0, 5) : ''}`}
      onClick={onClick}
      padded
      style={{
        display: 'flex',
        justifyContent: 'center',
        height: 100,
        width: 425,
        border: '1px solid rgba(152,162,179,.35)',
        ...(selected && {
          border: '1px solid var(--current-color, var(--accent))',
        }),
        boxShadow:
          '0px 0px 2px 0px rgba(152, 162, 179, .2), 2px 2px 4px 0px rgba(152, 162, 179, .2)',
      }}
      {...(selectable && { as: Card, link: true })}
    >
      <Header as="h3" style={{ margin: 0 }}>
        <Header.Content>{header}</Header.Content>
      </Header>
      {subheader && (
        <Header as="h4" disabled style={{ fontStyle: 'italic', position: 'absolute', bottom: -3 }}>
          <Header.Content>
            <Header.Subheader>{subheader}</Header.Subheader>
          </Header.Content>
        </Header>
      )}
      {children}
      <Icon
        {...(selected && { className: 'colored' })}
        iconSet="Lucide"
        name={iconName}
        size={80}
        style={{
          position: 'absolute',
          right: 5,
          opacity: selected ? 0.9 : 0.2,
        }}
      />
    </Segment>
  </Container>
);

export default Tile;
